import { Component, inject, Input, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: 'confirm-dialog.component.html'
})
export class ConfirmDialogComponent {

  private readonly translateService = inject(TranslateService);
  readonly activeModal = inject(NgbActiveModal);

  // 'default' or 'danger'
  readonly type = input('default');
  readonly title = input(this.translateService.instant('Modal.Confirm.Title'));
  readonly message = input(this.translateService.instant('Modal.Confirm.Message'));
  readonly yesText = input(this.translateService.instant('Button.Yes'));
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() noText = this.translateService.instant('Button.No');

  constructor() {
    if(this.type()=='danger'){
      this.noText = this.translateService.instant('Button.Cancel');
    }
  }
}
